/**
 *  Mobile refinements (Oct 2026)
 *  - Re-measure carousels once these styles have applied, and whenever slides resize.
 *  - Sticky "Add to cart" bar on product pages once the main button scrolls away.
 */
(() => {
  const remeasure = () => {
    document.querySelectorAll('slide-show.flickity-enabled').forEach((el) => {
      const flkty = window.Flickity && Flickity.data(el);
      if (flkty) flkty.resize();
    });
  };
  remeasure();
  window.addEventListener('load', remeasure);

  // Flickity keeps a stale viewport height when slides change size after it
  // measured them (late image loads, rotating a phone, the theme editor's
  // desktop/mobile switch), leaving a white gap under the banner.
  if ('ResizeObserver' in window) {
    // Debounced so it runs after Flickity's own (delayed) resize handler.
    let timer;
    const later = () => { clearTimeout(timer); timer = setTimeout(remeasure, 250); };
    const ro = new ResizeObserver(later);
    window.addEventListener('resize', later);
    const watch = () => document.querySelectorAll('slide-show .carousel__slide').forEach((slide) => ro.observe(slide));
    watch();
    document.addEventListener('shopify:section:load', watch);
  }
})();

(() => {
  if (!document.body.classList.contains('template-product')) return;

  const mq = window.matchMedia('(max-width: 767px)');
  const source = document.querySelector('.thb-product-detail #AddToCart') || document.getElementById('AddToCart');
  if (!source) return;

  const title = document.querySelector('.thb-product-detail .product-title');
  const price = document.querySelector('.thb-product-detail .price');

  const bar = document.createElement('div');
  bar.className = 'mobile-sticky-atc';
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML =
    '<div class="mobile-sticky-atc__info">' +
      '<span class="mobile-sticky-atc__title"></span>' +
      '<span class="mobile-sticky-atc__price"></span>' +
    '</div>' +
    '<button type="button" class="button mobile-sticky-atc__button" tabindex="-1"></button>';
  document.body.appendChild(bar);

  const barTitle = bar.querySelector('.mobile-sticky-atc__title');
  const barPrice = bar.querySelector('.mobile-sticky-atc__price');
  const barButton = bar.querySelector('button');

  // Keep the bar in step with variant changes (price, sold out, label).
  const sync = () => {
    if (title) barTitle.textContent = title.textContent.trim();
    if (price) {
      const current = price.querySelector('ins .amount') || price.querySelector('.amount');
      barPrice.textContent = (current || price).textContent.trim();
    }
    const label = source.querySelector('span:not(.loading-overlay)');
    barButton.textContent = (label ? label.textContent : source.textContent).trim();
    barButton.disabled = source.disabled;
  };
  sync();
  const observer = new MutationObserver(sync);
  observer.observe(source, { attributes: true, childList: true, subtree: true, characterData: true });
  if (price) observer.observe(price, { childList: true, subtree: true, characterData: true });

  // Clicking the bar presses the real button so the theme's cart logic runs.
  barButton.addEventListener('click', () => {
    if (!source.disabled) source.click();
  });

  // Show the bar only while the real button is scrolled up out of view.
  const update = () => {
    const show = mq.matches && source.getBoundingClientRect().bottom < 0;
    if (show === bar.classList.contains('is-visible')) return;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.body.classList.toggle('mobile-sticky-atc--active', show);
  };
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();
